<template>
  <fieldset>
    <legend>Donate with Credit card</legend>
    <i style="color:red">{{ donationError }}</i>
    <div ref="card" class="text-field donate-other w-input"></div>
    <a
        type="submit"
        data-wait="Please wait..."
        style="text-align:center;background-color:#29b366"
        class="button makedonation w-button"
        @click="submitDonation()"
    >{{ donationMessage }}</a>
  </fieldset>
</template>

<script>
import {loadStripe} from "@stripe/stripe-js";
import axios from "axios";

export default {
  name: "stripe-vue",
  metaInfo: {
    strip: null,
    card: null,
  },
  props: {
    donation: Object,
    amount: [String, Number],
    fullName: String,
    email: String,
    description: String
  },
  async mounted() {
    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_TOKEN);
    let elements = this.stripe.elements();
    this.card = elements.create("card");
    this.card.mount(this.$refs.card);
  },
  data() {
    return {
      stripe: null,
      card: null,
      charge: {},
      donationMessage: `Complete Donation`,
      donationOption: "",
      donationError: "",
      submitting: false,
    };
  },
  watch: {
    donation: {
      deep: true,
      handler(obj) {
        this.charge = {
          fullName: obj.fullName || obj.name || obj.firstName + ' ' + obj.lastName,
          email: obj.emailAddress || obj.email,
          description: this.description,
          amount: parseInt(obj.amount || 0),
          phone: obj.phoneNumber || null,
          address: {
            city: obj.city || null,
            line1: obj.streetAddress || null,
            postal_code: obj.zipCode || null,
            state: obj.state || null
          },
        }
      }
    }
  },
  methods: {
    async submitDonation() {
      this.donationError = "";
      if (this.submitting) {
        return
      }
      if (!this.charge.fullName) this.charge.fullName = this.fullName
      if (!this.charge.amount) this.charge.amount = this.amount
      if (!this.charge.email) this.charge.email = this.email

      if (!this.charge.fullName) {
        this.donationError = "Please add a Name"
        this.submitting = false;
        return
      }
      if (!this.charge.amount) {
        this.donationError = "Please Choose an Amount"
        this.submitting = false;
        return
      }
      if (!this.charge.email) {
        this.donationError = "Please add an Email Address"
        this.submitting = false;
        return
      }
      this.submitting = true;
      this.donationMessage = "Processing...";
      await this.stripe.createToken(this.card).then(async (result) => {
        if (result.error) {
          this.donationError = result.error.message;
          this.submitting = false;
        } else {
          await this.stripeTokenHandler(result.token)
              .then((response) => {
                this.submitting = false;
                if (response.status === 200) {
                  this.$emit("approve", "Thank you for your kind donation!")
                } else {
                  this.donationError =
                      "Could not process donation. Please try again";
                  this.$emit("error", "Could not process donation. Please try again")
                  this.donationMessage = "Complete Donation"
                }
              })
              .catch((err) => {
                this.submitting = false;
                this.donationError =
                    "Could not process donation. Please try again";
                this.$emit("error", err)
              });
        }
      });
    },
    stripeTokenHandler(token) {
      this.charge.token = token.id
      let options = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      return axios.post("/.netlify/functions/donation",
          this.charge,
          options
      );
    },
    validateDonation(e) {
      e.preventDefault();
      if (!this.donation.name) {
        this.donationError = "Name is a required field";
        return true;
      }
    },
  },
};
</script>

<style scoped>
.donate-other {
  padding: 14px 12px;
}
</style>
<style>
.no-show {
  opacity: 0;
}

.amountbtn {
  position: relative;
}

.dollor.dtitle {
  display: block;
  transform: translateY(6px);
}

.donation-title {
  font-size: 13px;
  padding-bottom: 4px;
  position: absolute;
  left: 10%;
  right: 10%;
  top: 5px;
  text-align: center;
  padding-right: 1px;
  padding-left: 1px;
}

.quote-wrapper {
  color: #2fb4fd;
  font-size: 28px;
  margin-left: 390px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100%;
  padding-bottom: 40%;
}

@media screen and (max-width: 991px) {
  .quote-wrapper {
    margin-left: auto;
    padding-bottom: 5px;
  }
}

@media screen and (max-width: 480px) {
  .quote-wrapper {
    display: none;
  }
}

.cta {
  text-decoration: none;
  cursor: pointer;
  width: 100px;
  display: block;
  margin: auto;
  margin-top: -30px;
  font-size: 20px;
  padding: 5px 20px 5px 20px;
  background: #2fb4fd;
  color: white;
}

.quote {
  background: rgba(255, 255, 255, 0.6);
  text-shadow: 0 0 20px 0 rgba(255, 255, 255, 0.87);
  /* border-top:3px solid white; */
  /* border-bottom:3px solid white; */
  padding: 30px 20px;
}

#cardNumber {
  padding-top: 16px;
}

input[type="radio"]:checked + .amountbtn {
  color: white;
  background: #2fb5fd;
}

.other-payment {
  font-size: 13px;
  color: #2fb4fd;
  cursor: pointer;
  display: block;
  transform: translateY(-10px);
  font-family: "Montserrat", "Bagel", sans-serif;
}

.radio-side-label:before {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  border-radius: 100%;
  border: 1px solid #ccc;
  background: #ccc;
}

input[type="radio"]:checked + .radio-side-label:before {
  background: #2fb5fd;
}

.paypal-btn {
  display: block;
  width: 100%;
  height: 46px;
  margin-right: auto;
  margin-left: auto;
  padding: 14px 12px 12px 15px;
  border: 1px none #000;
  background-color: #ffc33b;
  background-size: 67px, 18px;
  background-repeat: no-repeat, no-repeat;
  -webkit-transition: all 200ms ease;
  transition: all 200ms ease;
  font-size: 18px;
  line-height: 20px;
  color: #fff;
  font-weight: 300;
  border-radius: 100px;
  text-align: center;
}

.paypal-btn img {
  margin-right: 3px;
}

.donate-tab:first-child {
  border-right: none;
}

.donate-tab.active {
  border-style: solid;
  border-width: 1px;
  border-color: #e7e7e7;
  border-bottom: none;
  background: white;
  color: #009be5;
}

.donate-tab {
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  width: 50%;
  display: inline-block;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 0px;
  -webkit-box-flex: 0;
  -webkit-flex: 0 30%;
  -ms-flex: 0 30%;
  flex: 0 30%;
  background: #009be515;
  color: #9d9d9d;
  border-radius: 2px;
  text-align: center;
}

.button-box {
  max-height: 300px;
  transition: all 0.15s ease-out;
  overflow: hidden;
  opacity: 1;
}

.hide-box {
  transform: translateY(50px);
  max-height: 0px;
  opacity: 0;
}

.donate-blue-box.card {
  max-height: 400px;
  padding: 20px;
}

.donate-blue-box {
  position: relative;
  transition: max-height 0.25s ease;
  max-height: 0px;
  overflow: hidden;
  border: 1px solid;
  border-color: #e7e7e7;
  background: white;
  z-index: 3;
}

/* ENkeB8qdcNkgM8bR6mwVqJsrwvLgbECepZ376DBM6orcIixtSbQE62OinG8BAXHhrIZVA5KseZ8EJlnf */
</style>